var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonnow5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 182,
    viewBox: "0 0 177 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-157.466 -77.854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.69,
    cy: 86.69,
    r: 86.69,
    transform: "translate(159.91 82.806)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.566,83.993a80.469,80.469,0,1,0,80.469,80.469,80.469,80.469,0,0,0-80.469-80.469Zm-21.515,25.154c3.856.059,6.683,1.366,7.88,3.644,2.542,4.837-2.8,12.649-11.939,17.45s-18.6,4.772-21.144-.066,2.8-12.648,11.939-17.449a28.822,28.822,0,0,1,13.263-3.579Zm50.034,6.516c3.606,0,6.53,2.088,6.532,4.664a3.422,3.422,0,0,1-.206,1.14c5.6.727,9.528,3.334,9.537,6.326,0,3.607-5.64,6.532-12.6,6.532s-12.6-2.925-12.6-6.532c.005-1.809,1.457-3.536,4.009-4.769a3.842,3.842,0,0,1-1.21-2.7c0-2.577,2.927-4.665,6.535-4.664Zm-37.176,41.474c4.3,0,7.78,1.858,7.777,4.15s-3.481,4.147-7.776,4.147-7.775-1.856-7.776-4.147,3.478-4.15,7.775-4.15Zm39.271,18.927a24.333,24.333,0,0,1,10.712,2.823c7.656,3.882,12.2,10.315,10.143,14.369s-9.928,4.193-17.585.311-12.2-10.314-10.143-14.368c1.007-1.986,3.487-3.116,6.876-3.135Zm-72.889.344a13.626,13.626,0,0,1,13.6,12.826A7.724,7.724,0,1,1,206.2,201.76a13.619,13.619,0,1,1-6.908-25.351Z",
    transform: "translate(5.034 5.034)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonnow5);
export default __webpack_public_path__ + "static/media/moonnow5.fa41c581bf51171e8bf492880948bb48.svg";
export { ForwardRef as ReactComponent };